// Variables de estado
export const STATE_INITIATE = 0;
export const STATE_UPDATE = 1;

export const IMAGE_FALLBACK =
  'data:image/png;base64,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';

// Keys
export const GOOGLE_MAP_KEY = 'AIzaSyAmw_wSUKT6_Wxu_By5vFAOfRn6YFatSyo';

export const MERCADO_PAGO_ACCESS_TOKEN =
  'TEST-261070537143985-090607-61e7116a1ae342884273a1f3b82bcacf-446971035';

// S3 Url
export const IMAGE_URL = 'https://galery-doghouser.s3-us-west-2.amazonaws.com/';

export const GET_STREAM_KEY = 'uhazz62khjq4';

export const GET_STREAM_ADMIN = 'doghouserpe';

export const BOOLEAN_VALUES = {
  0: false,
  1: true,
};

export const BOOLEAN_TEXT = {
  0: false,
  1: true,
};

export const NUMBER_TO_BOOLEAN = {
  0: false,
  1: true,
};

export const BOOLEAN_TO_NUMBER = {
  false: 0,
  true: 1,
};

export const NUMBER_TO_TEXT = {
  0: '0',
  1: '1',
};

export const TEXT_TO_NUMBER = {
  0: 0,
  1: 1,
};

export const TEXT_TO_BOOLEAN = {
  0: false,
  1: true,
};

// Tipos de Mascotas
export const PET_TYPE = {
  1: 'Perro',
  2: 'Gato',
  3: 'Conejo',
  4: 'Exotico',
};

// Tipos de Mascotas
export const PET_TYPE_VALUE = {
  has_dogs: 1,
  has_cats: 2,
  has_rabbits: 3,
  has_exo: 4,
};

// Tamaño de Mascotas && numero = tipo de mascota
export const PET_SIZE = {
  0: 'Pequeño',
  1: 'Mediano',
  2: 'Grande',
};

// Meses && numero = nombre del mes
export const VARIANT_MONTH = {
  1: 'Enero',
  2: 'Febrero',
  3: 'Marzo',
  4: 'Abril',
  5: 'Mayo',
  6: 'Junio',
  7: 'Julio',
  8: 'Agosto',
  9: 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre',
};

// Tipos de Mascotas
export const PLACE_TYPE = {
  1: 'Centro Comercial',
  2: 'Restaurante',
  3: 'Cafetería',
};

// Variante del nivel del cuidador
export const RESERVATION_STATUS = {
  1: 'Pendiente',
  2: 'Pendiente de pago',
  3: 'Próxima',
  4: 'Rechazada',
  5: 'Terminado', // Este estado no exite en la base de datos
  6: 'Comentado',
  7: 'Pasada',
};

// Variante del nivel del cuidador
export const LEVEL_VARIANT = {
  1: 'junior',
  2: 'senior',
  3: 'super',
};

// Nivel de Cuidador
export const LEVEL_NAME = {
  1: 'Houser Junior',
  2: 'Houser Senior',
  3: 'Super Houser',
};

// Tipo de mondeda por Pais && pais = tipo de moneda
export const CURRENCY_ABREVIATED = {
  Chile: 'CLP',
  Perú: 'PEN',
  Colombia: 'COP',
  España: 'EURO',
  Brazil: 'BRL',
};

// Tipo de mondeda por Pais && pais = tipo de moneda
export const CURRENCY_BY_COUNTRY = {
  Perú: 'S/.',
  Colombia: '$',
  España: '€',
};

// Numero de Telefono por Pais && pais = numero de telefono
export const NUMBER_BY_COUNTRY = {
  Perú: 51995759034,
  Colombia: 573013385301,
  España: 34633053593,
};

export const PRICE_EXCLUSIVO_BY_COUNTRY = {
  Perú: 60,
  Colombia: 45000,
  España: 18,
};

export const PRICE_COMPARTIDO_BY_COUNTRY = {
  Perú: 50,
  Colombia: 37500,
  España: 18,
};

export const PRICE_GUARDERIA_BY_COUNTRY = {
  Perú: 40,
  Colombia: 30000,
  España: 14,
};

// Meses && numero = nombre del mes
export const RANDOM_COLOR = {
  1: '#f9a64a',
  2: '#7e57c2',
  3: '#00897b',
  4: '#2196f3',
  5: '#ff5722',
  6: '#66bb6a',
  7: '#e53935',
  8: '#ab47bc',
  9: '#536dfe',
  10: '#757575',
};
